<template lang="pug">
    ListItem
        ListItemMeta(:title='$t("accountInfo.history.titleText")') 
            template(slot="description")
                Spin(size="large" v-if="spinShow")
                div(v-else)
                    p(v-if="paymentHistoryData.length == 0") {{ $t('accountInfo.noPayDataText') }}
                    //- div(style="display: flex; flex-direction: row; align-items: center;width: 100vw" v-else)
                    Table(v-else height="250" width="100%" max-height="250" :columns="paymentHistoryColumns" :data="paymentHistoryData" :disabled-hover="true" )
                        template(slot-scope="{row}" slot="plan")
                            span {{ $t('accountInfo.'+row.plan) }}
                        template(slot-scope="{row}" slot="price")
                            span $ {{row.amount}} {{row.currency.toUpperCase()}}
                        //- template(slot-scope="{row}" slot="total")
                        //-     span $ {{row.total}} USD

        //- template(slot="extra") 
            li
                Button.cardBtn(type="" disabled @click="showPaymentHistory") 查看更多
</template>
<script>
import { _getCusInvoices, _getInvoicePDF } from "@/api/billing";

export default {
    name: "HistoryListItem",
    props: ["creditCardData", "userInfoData"],
    data() {
        return {
            spinShow: false,
            paymentHistoryColumns: [
                {
                    title: "Invoice N.O",
                    key: "number",
                    minWidth: 60
                },
                {
                    title: "Plan",
                    key: "plan",
                    align: "center",
                    minWidth: 30,
                    slot: "plan"
                },
                {
                    title: "Charge Date",
                    key: "created",
                    minWidth: 50
                },
                {
                    title: "Use Interval",
                    key: "period",
                    minWidth: 110
                },
                {
                    title: "Status",
                    key: "status",
                    align: "center",
                    minWidth: 30
                },
                {
                    title: "Total",
                    key: "amount",
                    slot: "price",
                    minWidth: 50
                },
                {
                    title: "PDF",
                    key: "action",
                    width: 100,
                    align: "center",
                    render: (h, params) => {
                        return h("div", [
                            h(
                                "Button",
                                {
                                    props: {
                                        type: "primary",
                                        size: "small",
                                        loading: params.row.isloading
                                    },
                                    style: {
                                        marginRight: "5px"
                                    },
                                    on: {
                                        click: () => {
                                            this.openPDF(params);
                                        }
                                    }
                                },
                                "View"
                            )
                        ]);
                    }
                }
            ],
            paymentHistoryData: [
                // {
                //     invoiceId: "in_1LOEidI7PrA2LVMvmcKtL9s3",
                //     number: "0A5C1EBD-0001",
                //     subscriptionId: "sub_1LOEidI7PrA2LVMvFfqLW0TI",
                //     creatDate: "1658468891",
                //     period: "2022/05/01-2022/05/31",
                //     status: "paid",
                //     amount: 40,
                //     currency: "usd",
                //     subscriptionItem: []
                // }
            ]
        };
    },
    methods: {
        // showPaymentHistory() {
        //     this.$emit("openModalEvent", { component: HistoryModal, type: "add" });
        // }
        async getCusHistoryInvoice() {
            let getCusInvoicesResult = await _getCusInvoices({
                groupName: this.$store.state.queryGroupName,
                customerId: this.userInfoData.customerId
            });
            this.paymentHistoryData = getCusInvoicesResult.data.data.invoice;
            this.paymentHistoryData = this.paymentHistoryData.map(e => {
                e.isloading = false;
                return e;
            });
            // console.log(this.paymentHistoryData);
            let InvoiceData = [];
            this.paymentHistoryData.forEach(e => {
                if (e.status == "open" || e.status == "draft") {
                    InvoiceData.push(e.invoiceId);
                }
            });
            this.$emit("reloadInvoiceData", InvoiceData);
            this.spinShow = false;
        },
        async openPDF(data) {
            // console.log(data.row);
            data.row.isloading = true;
            let number = data.row.number;
            let invoiceId = data.row.invoiceId;
            let groupName = this.$store.state.queryGroupName;
            let PDF = await _getInvoicePDF({
                groupName,
                number,
                invoiceId
            });
            var file = new Blob([PDF.data], { type: "application/pdf" });
            var fileURL = URL.createObjectURL(file);
            window.open(fileURL);
            data.row.isloading = false;
        }
    },
    async mounted() {
        this.spinShow = true;
        await this.getCusHistoryInvoice();
    },
    watch: {
        userInfoData: async function name() {
            await this.getCusHistoryInvoice();
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/Payment/history/listItem.vue